import React, { useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { AppPage } from '../AppContent';
import { FriendRequestItem } from '../components/friendrequest/FriendRequestItem';
import { useUserNetwork } from '../hooks/WPHooks';
import { AppContext } from '../state/AppContextProvider';

interface FriendRequestPageProps extends RouteComponentProps {}

const FriendRequestPage: React.FC<FriendRequestPageProps> = (
  props: FriendRequestPageProps
) => {
  const { state } = useContext(AppContext);

  const { userNetwork, update, fetch, getMyFriendRequests } = useUserNetwork(
    state.user ? state.user.id : null
  );

  // build list of friend request sended by others
  const myFriendRequests = getMyFriendRequests();

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppPage scrollable={true}>
      <div className="px-4 md:px-14 min-h-screen">
        <h1 className="text-center text-2xl font-medium mb-4 mt-4">
          <FormattedMessage id="Contact request title" />
        </h1>
        {userNetwork.length > 0 && (
          <>
            {myFriendRequests.length === 0 ? (
              <h2 className="text-center text-lg">
                <FormattedMessage id="No new contact request" />
              </h2>
            ) : (
              <ul className="flex flex-col mt-8 gap-1 md:overflow-hidden md:rounded-2xl md:p-4 md:bg-white">
                {myFriendRequests.map((friendRequest, index) => (
                  <FriendRequestItem
                    key={'friendRequest_' + index}
                    idUser={friendRequest.acf.user_a}
                    idNetwork={friendRequest.id}
                    update={update}
                  />
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </AppPage>
  );
};

export default FriendRequestPage;
